import { render, staticRenderFns } from "./nice-pay.vue?vue&type=template&id=7dc49b26&scoped=true"
import script from "./nice-pay.vue?vue&type=script&lang=js"
export * from "./nice-pay.vue?vue&type=script&lang=js"
import style0 from "./nice-pay.vue?vue&type=style&index=0&id=7dc49b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc49b26",
  null
  
)

export default component.exports